export default __webpack_public_path__ + "static/media/music_arts.967836ac.jpg";